import { render, staticRenderFns } from "./Indicatori.vue?vue&type=template&id=7e3da990"
import script from "./Indicatori.vue?vue&type=script&lang=js"
export * from "./Indicatori.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports